module.exports = __webpack_public_path__ + "img/dutyFree.6e1c6619.jpg";